import type {
  SurveyFilterOption,
  SurveyFilterOptions,
  SurveyFilterOptionsParams,
} from 'app/common/types/surveys'

import type { Request } from '../../../index'

type SurveyFilterOptionDto = {
  id: string | number
  title: string
  district_id?: number | null
  city_id?: number | null
}

type SurveyFilterOptionsParamsDto = {
  city_id?: Array<number>
  district_id?: Array<number>
  school_type?: string | Array<string>
}

type SurveyFilterOptionsResultDto = {
  survey_kind_label?: string
  survey_location_label?: string
  cities?: Record<string, SurveyFilterOptionDto> | Array<SurveyFilterOptionDto>
  districts?: Record<string, SurveyFilterOptionDto> | Array<SurveyFilterOptionDto>
  schools?: Record<string, SurveyFilterOptionDto | Array<SurveyFilterOptionDto>>
  school_types?: Array<{
    value: string
    label: string
  }>
}
const convertIds = (ids: Array<string>) =>
  ids.length ? ids.map((v) => parseInt(v, 10)) : undefined

export const convertParams = (
  params: SurveyFilterOptionsParams,
): [SurveyFilterOptionsParamsDto, void] => [
  {
    city_id: convertIds(params.cityIds),
    district_id: convertIds(params.districtIds),
    school_type: params.schoolTypes.length === 1 ? params.schoolTypes[0] : params.schoolTypes.length ? params.schoolTypes : undefined,
  },
  undefined,
]

const convertOptions = (items?: Record<string, SurveyFilterOptionDto> | Array<SurveyFilterOptionDto>): Array<SurveyFilterOption> =>
  (Array.isArray(items) ? items : Object.values(items || {})).map((item) => ({
    id: String(item.id), title: item.title,
    districtId: item.district_id == null ? undefined : String(item.district_id),
    cityId: item.city_id == null ? undefined : String(item.city_id),
  })).sort((a, b) => a.title.localeCompare(b.title, 'ru'))

export const convertResult = (data: SurveyFilterOptionsResultDto): SurveyFilterOptions => ({
  surveyKindLabel: data.survey_kind_label,
  surveyLocationLabel: data.survey_location_label,
  cities: convertOptions(data.cities),
  districts: convertOptions(data.districts),
  schools: Object.entries(data.schools || {}).flatMap(([districtId, group]) =>
    convertOptions(Array.isArray(group) ? Object.fromEntries(group.map(item => [item.id, item])) : { [group.id]: group })
      .map(item => ({ ...item, districtId: item.districtId || (Array.isArray(group) ? districtId : undefined) })),
  ),
  schoolTypes: (data.school_types || [])
    .filter((item) => item.value)
    .map((item) => ({
      id: item.value,
      title: item.label,
    })),
})

export const GET_SURVEY_FILTER_OPTIONS: Request<
  SurveyFilterOptionsParams,
  SurveyFilterOptions,
  void
> = ['food/surveys/filter_options', 'get', ['data']]
